import * as React from 'react'
import { useRowSelection } from './hooks'
import type { WWMXGridProps } from './typings'
import { GridComponent } from './GridComponent'
import { BulkActionContextProvider, BulkActionsSidebar } from './atoms'

import Box from '@mui/material/Box'

export const WWMXGrid: React.FC<WWMXGridProps> = (props) => {
  const {
    bulkActionSidebars,
    width,
    exportClickCallback,
    isDensityEnable,
    isExportEnable,
    ...rest
  } = props

  const { selectionModel, onSelectionModelChange } = useRowSelection(props)

  const disableInteraction = React.useMemo(
    () => rest.loading || selectionModel.length > 0,
    [rest.loading, selectionModel.length],
  )
  return (
    <BulkActionContextProvider selectedRows={selectionModel}>
      <Box
        display="flex"
        flexDirection="row"
        height="100%"
        minHeight={0}
        width={width ?? 'auto'}
      >
        <GridComponent
          {...rest}
          disableInteraction={disableInteraction}
          rowSelectionModel={selectionModel}
          onRowSelectionModelChange={onSelectionModelChange}
          exportClickCallback={exportClickCallback}
          isDensityEnable={isDensityEnable}
          isExportEnable={isExportEnable}
        />
        <BulkActionsSidebar bulkActionSidebars={bulkActionSidebars} />
      </Box>
    </BulkActionContextProvider>
  )
}
WWMXGrid.displayName = 'WWMXGrid'
